var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M1567.312,1040.485a1.017,1.017,0,0,0-1.437,0l-8.626,8.626-3.206-3.206a1.016,1.016,0,0,0-1.437,1.437l3.783,3.783a1.014,1.014,0,0,0,.718.3.766.766,0,0,1,.283,0,1.015,1.015,0,0,0,.718-.3l9.2-9.2a1.017,1.017,0,0,0,0-1.437",
    transform: "translate(-1552.309 -1040.188)",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox-off",
    transform: "translate(-989 -469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "on"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 27,
    height: 27,
    rx: 3,
    transform: "translate(989 469)",
    fill: "#23bb79"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(994.616 476.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 30.038,
    height: 25.973,
    transform: "translate(-7.369 -7.369)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "off"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_62-2",
    "data-name": "Rectangle 62",
    transform: "translate(989 469)",
    fill: "#fff",
    stroke: "#404149",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 26,
    rx: 2.5,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOff);
export default __webpack_public_path__ + "static/media/checkbox-off.d65a8045dbc6dc3de8fee1675edd2248.svg";
export { ForwardRef as ReactComponent };